<template>
  <div class="animated fadeIn">
    <b-dropdown
      v-if="Object.entries(laboratories).length > 1"
      :text="getCurrentLabName()"
      variant="outline-primary"
      size="sm"
    >
      <!-- Lab selection options -->
      <template v-for="(lab_opt, index) in laboratories">
        <b-dropdown-item
          :key="index"
          v-if="!isCurrentLab(lab_opt)"
          href="#"
          @click="updateLabContext(lab_opt)"
        >
          {{ lab_opt.name }}
        </b-dropdown-item>
      </template>
    </b-dropdown>
  </div>
</template>

<script>
import { LAB_CONTEXT_SET } from "@/store/action-types";

export default {
  name: "LabContextSelect",
  data() {
    return {
      laboratory: {},
      laboratories: []
    };
  },
  methods: {
    /**
     * Fetch the current lab from the context
     * @returns object|null
     */
    getCurrentLab() {
      if (typeof this.$store.getters.getLaboratoryContext === "object") {
        return this.$store.getters.getLaboratoryContext;
      } else {
        return null;
      }
    },
    /**
     * fetches the current lab name from the context
     * @returns string
     */
    getCurrentLabName() {
      if (this.getCurrentLab()) {
        return this.getCurrentLab().name;
      } else {
        return "";
      }
    },
    isCurrentLab(laboratory) {
      let current_lab = this.getCurrentLab();
      return (
        typeof current_lab === "object" && current_lab.id === laboratory.id
      );
    },
    updateLabContext(lab) {
      // set lab context
      this.$store.dispatch(LAB_CONTEXT_SET, { laboratory: lab }).then(() => {
        this.$router.push("/dashboard");
      });
    },

    /**
     *
     * @returns {getters.getLaboratoryContextList}
     */
    fetchLaboratories() {
      return this.$store.getters.getLaboratoryContextList;
    }
  },
  watch: {},
  mounted() {
    // set lab list in object
    this.laboratories = this.fetchLaboratories();
  }
};
</script>
